import { gql } from '@apollo/client';

const HOLTER_ECG_DATA_MAP_QUERY = gql`
  query holterEcgDataMap($filter: HolterEcgDataMapFilter!) {
    holterEcgDataMap(filter: $filter) {
      isSuccess
      message
      ecgDataMap {
        samplingFrequency
        gain
        channels
        data {
          id
          start
          stop
          sampleSize
          dataUrl
          maxHrs
          minHrs
          avgHrs
          channel
          beatFinalPath
          beatPath
          beatInfo
        }
        querySignature
      }
    }
  }
`;

export default HOLTER_ECG_DATA_MAP_QUERY;
